import React, { useEffect } from 'react';

const HeadwayBadge = () => {
    useEffect(() => {
        console.log('Initializing headway widget');
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://cdn.headwayapp.co/widget.js';
        document.head.appendChild(script);
        var config = {
            selector: '.headway-badge',
            account: 'yoEvL7'
        };

        script.onload = () => {
            (window as any).Headway.init(config);
        };
    }, []);

    return (
        <React.Fragment>
            <div>
                <span className='headway-badge' id='headway-badge'></span>
            </div>
        </React.Fragment>
    );
};

export default HeadwayBadge;
